import { useQuery } from "@tanstack/react-query"

import { adminApiService } from "../services/admin-api-service"

export const TOOL_CATALOG_KEYS = {
  catalog: (organizationId?: string) => ["admin", "tool-catalog", organizationId] as const,
  tutorial: (toolName: string) => ["admin", "tool-tutorial", toolName] as const,
}

/**
 * Fetches the agent tool catalog, with per-organization availability.
 * Pass the edited agent's organization_id so flag-gated tools resolve correctly.
 */
export function useToolCatalog(organizationId?: string) {
  return useQuery({
    queryKey: TOOL_CATALOG_KEYS.catalog(organizationId),
    queryFn: () => adminApiService.getToolCatalog(organizationId),
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000,
  })
}

/**
 * Fetches a single tool's tutorial/FAQ. Only enabled when `toolName` is set,
 * so it loads lazily when the tutorial sheet opens.
 */
export function useToolTutorial(toolName: string | null) {
  return useQuery({
    queryKey: TOOL_CATALOG_KEYS.tutorial(toolName || ""),
    queryFn: () => adminApiService.getToolTutorial(toolName!),
    enabled: !!toolName,
    staleTime: 5 * 60 * 1000,
  })
}
